import { render } from "./SafetyRegulations.vue?vue&type=template&id=655834f4&scoped=true"
import script from "./SafetyRegulations.vue?vue&type=script&lang=js"
export * from "./SafetyRegulations.vue?vue&type=script&lang=js"

import "./SafetyRegulations.vue?vue&type=style&index=0&id=655834f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-655834f4"]])

export default __exports__